import http from './http'

export default {
  getList: params => http.get('/v2/members', { params }),
  // "Archive" itself lives on the Member Profile page (Tabs/Details.vue) — restore is the only
  // member-lifecycle action this list page performs (the "Deleted" tab's Restore button).
  restore: id => http.patch(`/v2/members/${id}/restore`, {}, { silent: true }),
  // Shared member pickers (CAM-1477 part 2) — `params.context` is 'owner' or 'competitor'.
  options: params => http.get('/v2/members/options', { params })
}



// WEBPACK FOOTER //
// ./src/services/api/members.js